var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanting1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_12891)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_934_12891",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7499 49.25V0.750145H1.25V49.25H49.7499Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_934_12891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6523 29.4746C29.7164 28.2815 30.1682 26.1916 32.2889 24.3136C38.7453 18.596 46.8524 14.4086 46.8524 14.4086",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6328 29.4746C29.5614 28.2757 29.0972 26.1728 26.9984 24.3142C20.542 18.5965 12.5059 14.4294 12.5059 14.4294",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6436 29.4746V0.733386",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2686 39.9766L35.3847 39.4465",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5655 40.8789L13.6559 46.2317C14.0335 46.8855 13.8094 47.7215 13.1555 48.0992L11.4494 49.0841C10.7954 49.4618 9.95936 49.2376 9.58192 48.5837L3.35723 37.8023C2.97969 37.1485 3.20372 36.3124 3.85762 35.9349L5.56377 34.9498C6.21767 34.5723 7.0538 34.7963 7.43124 35.4502L8.84989 37.9072",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3846 45.7616L15.1139 44.2277C15.3932 43.9799 15.7322 43.8093 16.0975 43.7325C16.4628 43.6556 16.8418 43.6753 17.1972 43.7896L23.1375 45.6988C23.7882 45.9555 24.4911 46.0523 25.1871 45.9813L37.0126 44.7678C37.7493 44.6923 38.4577 44.4301 39.0775 44.0037L47.2406 38.3882C47.8958 37.7749 48.0174 36.7441 47.5244 35.9804C46.9849 35.1448 45.9066 34.9252 45.1108 35.489L39.8422 38.2583C38.4547 38.9877 36.9343 39.3931 35.3847 39.4471L35.4527 38.3233C35.3246 36.966 34.3332 35.8765 33.0519 35.6854L27.1634 34.9708C25.805 34.7681 25.1262 34.2883 23.942 33.5581C22.7864 32.8454 20.6379 31.9789 19.4741 31.6304C17.4309 31.0184 15.223 31.3062 13.3626 32.3494L7.5293 35.6202",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6622 21.2059C45.9504 18.8776 46.7279 16.0037 46.966 14.7902C47.0257 14.4861 46.7335 14.1972 46.3736 14.2041C43.6018 14.2569 33.3408 15.0578 32.2268 23.9729C32.193 24.2435 32.4341 24.499 32.7516 24.5283C36.2477 24.851 38.8968 24.2667 40.9021 23.2362",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0014 14.204C15.7733 14.2568 26.0343 15.0577 27.1483 23.9728C27.1822 24.2435 26.941 24.4989 26.6235 24.5283C15.3122 25.5726 12.8663 17.1201 12.4092 14.7901C12.3494 14.4861 12.6416 14.1971 13.0014 14.204Z",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9754 0.917241C29.9403 0.860821 29.8915 0.814272 29.8334 0.781994C29.7754 0.749716 29.71 0.732775 29.6436 0.732775C29.5772 0.732775 29.5119 0.749716 29.4538 0.781994C29.3958 0.814272 29.3469 0.860821 29.3119 0.917241C27.8627 3.20044 22.4729 12.7775 29.6318 18.9746H29.6553C36.8143 12.7775 31.4245 3.20044 29.9754 0.917241Z",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0543 36.043L40.6046 33.2921C34.8172 28.677 26.7606 28.2445 20.5479 31.9944",
    stroke: "#212529",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_12891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanting1);
export default __webpack_public_path__ + "static/media/planting 1.01c0804f49919c3bfe934d245082b3df.svg";
export { ForwardRef as ReactComponent };